<template>
    <a :href="url" class="prod-card">
        <div class="pc-img">
            <img v-if="product?.thumbnail?.url" :src="product.thumbnail.url" :alt="product.name" />
            <div v-else class="ph"><span class="ph-lbl">{{ product.name }}</span></div>
            <span class="pc-tag" v-if="firstCategory">#{{ firstCategory }}</span>
            <span class="pc-fade"></span>
            <span class="pc-view">{{ translations?.buttons?.see_more || 'Ver detalle' }}</span>
        </div>
        <h3>{{ product.name }}</h3>
        <p class="pc-desc" v-if="product.blurb">{{ product.blurb }}</p>
        <div class="pc-foot">
            <span class="pc-price" v-if="!product.hide_price">
                {{ priceFormatter.format(product.price) }} {{ product.currency }}
            </span>
            <span class="pc-price" v-else></span>
            <span class="pc-cart">+</span>
        </div>
    </a>
</template>

<script>
export default {
    inject: ['locale', 'translations'],

    props: {
        product: {
            required: true,
            type: Object
        }
    },

    computed: {
        priceFormatter() {
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
            });
        },

        firstCategory() {
            return this.product?.categories?.[0]?.name
        },

        url() {
            return '/' + this.locale + '/' + this.prefix + '/' + this.product.slug
        },

        prefix() {
            let prefixes = {
                es: 'productos',
                en: 'products',
            }
            return prefixes[this.locale]
        }
    }
}
</script>
